import React, { useContext, useEffect, useState } from 'react';
import { withRouter } from 'react-router-dom';
import _ from 'lodash';
import { connect } from 'react-redux';
import withForm from 'modules/common/hoc/withForm';
import Modal from 'modules/common/components/Modal';
import useFormValidator from 'useFormValidator';
import PropTypes from 'prop-types';
import { ModalContext } from 'App';
import Select from 'react-select';
import * as c from '../constant';
import * as actions from '../action';

function UpdateModal({
  updateCedulaFees,
  getNewOtherFeesList,
  updateList,
  id,
  history,
  getSingleNewOtherFees,
  getCedulaCalculationList,
  updating,
  ordinanceRevisionId,
  cedulaCalculationList
}) {
  const [formData, setFormData] = useState({
    business_type: '',
    cedula_fixed_fee: '',
    cedula_base_fee: '',
    cedula_for_every_fee: '',
    cedula_additional_fee: '',
    cedula_max_fee: ''
  });

  const validateForm = useFormValidator(formData, {
    business_type: 'required',
    cedula_fixed_fee: 'required',
    cedula_base_fee: 'required',
    cedula_for_every_fee: 'required',
    cedula_additional_fee: 'required',
    cedula_max_fee: 'required'
  });

  const setModal = useContext(ModalContext);

  const handleOnSubmit = e => {
    e.preventDefault();

    const newOtherFeesId = _.get(updateList, 'bpls_other_fee_id');
    const args = {
      ...formData,
      business_type: _.get(formData, 'business_type').toUpperCase(),
    };

    updateCedulaFees(id, newOtherFeesId, args, () => {
      setModal({ isOpen: false });
      getNewOtherFeesList({ ordinance_revision_id: ordinanceRevisionId });
      getSingleNewOtherFees(newOtherFeesId);
      history.push(`/bpls/tax-revenue/new-other-fees/${newOtherFeesId}`);
      getCedulaCalculationList(newOtherFeesId);
    });
  };

  const closeModal = e => {
    e.preventDefault();
    setModal({ isOpen: false });
  };

  const onSetFormData = () => {
    if (!_.isEmpty(updateList)) {
      const args = {
        ...updateList,
      };
      setFormData(_.pick(args, _.keys(c.CEDULA_FORM_DATA)));
    }
  };

  useEffect(() => {
    onSetFormData();
  }, []);

  const onChange = e => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleOnChangeSelect = key => e => {
    setFormData({
      ...formData,
      [key]: e ? e.value : '',
    });
  };

  const listBusinessTypeOptions = c.BUSINESS_TYPE.map((businessType) => ({
    label: _.get(businessType, 'label'),
    value: businessType.value,
  }));

  const selectedBusinessType = [];
  cedulaCalculationList.map((item) =>
    selectedBusinessType.push(_.get(item, 'attributes.business_type'))
  );

  const filteredBusinessType = _.filter(
    listBusinessTypeOptions,
    (v) => !_.includes(selectedBusinessType, v.label) && (v.label === 'CORPORATION' || v.label === 'SOLE PROPRIETORSHIP')
  );

  useEffect(() => {
    validateForm.validate();
  }, [Object.values(formData).join(',')]);

  return (
    <Modal.Body>
      <form onSubmit={handleOnSubmit}>
        <div className="row">
          <div className="col-12 form-group">
            <label className="full-label mb-0">
              Business Type: {validateForm.renderMessage('business_type')}
            </label>
            <Select
              name="business_type"
              placeholder="Select Business Type"
              onChange={handleOnChangeSelect('business_type')}
              options={filteredBusinessType}
              value={
                c.BUSINESS_TYPE.find(
                  item =>
                    _.get(formData, 'business_type') ===
                    _.get(item, 'value')
                ) || ''
              }
            />
          </div>
          <div className="col-12 form-group">
            <label htmlFor="last_name" className="full-label mb-0">
              Fixed Fee: {validateForm.renderMessage('cedula_fixed_fee')}
            </label>
            <input
              className="form-control"
              type="number"
              name="cedula_fixed_fee"
              onChange={onChange}
              placeholder="Ex. 1.00"
              value={_.get(formData, 'cedula_fixed_fee')}
            />
          </div>
          <div className="col-12 form-group">
            <label className="full-label mb-0">
              Base Fee: {validateForm.renderMessage('cedula_base_fee')}
            </label>
            <input
              className="form-control"
              type="number"
              name="cedula_base_fee"
              onChange={onChange}
              placeholder="Ex. 1.00"
              value={_.get(formData, 'cedula_base_fee')}
            />
          </div>
          <div className="col-12 form-group">
            <label className="full-label mb-0">
              For Every Fee: {validateForm.renderMessage('cedula_for_every_fee')}
            </label>
            <input
              className="form-control"
              type="number"
              name="cedula_for_every_fee"
              onChange={onChange}
              placeholder="Ex. 1.00"
              value={_.get(formData, 'cedula_for_every_fee')}
            />
          </div>
          <div className="col-12 form-group">
            <label className="full-label mb-0">
              Additional Fee: {validateForm.renderMessage('cedula_additional_fee')}
            </label>
            <input
              className="form-control"
              type="number"
              name="cedula_additional_fee"
              onChange={onChange}
              placeholder="Ex. 1.00"
              value={_.get(formData, 'cedula_additional_fee')}
            />
          </div>
          <div className="col-12 form-group">
            <label className="full-label mb-0">
              Max Fee: {validateForm.renderMessage('cedula_max_fee')}
            </label>
            <input
              className="form-control"
              type="number"
              name="cedula_max_fee"
              onChange={onChange}
              placeholder="Ex. 1.00"
              value={_.get(formData, 'cedula_max_fee')}
            />
          </div>
        </div>

        <div className="d-flex justify-content-center">
          <button
            disabled={updating || !validateForm.response.is_passed}
            type="submit"
            className="mt-3 btn btn-primary cms-bg-color-primary cms-outline-primary     mr-3"
          >
            <span className="font-weight-bold">
              {updating ? <i className="fa fa-spin fa-spinner" /> : `Submit`}
            </span>{' '}
          </button>
          <button
            type="button"
            onClick={closeModal}
            className="mt-3 btn btn-dark "
          >
            <span className="font-weight-bold">Cancel</span>
          </button>
        </div>
      </form>
    </Modal.Body>
  );
}

UpdateModal.propTypes = {
  updateList: PropTypes.instanceOf(Object).isRequired,
  updateCedulaFees: PropTypes.instanceOf(Function).isRequired,
  getNewOtherFeesList: PropTypes.instanceOf(Function).isRequired,
  id: PropTypes.string.isRequired,
  history: PropTypes.instanceOf(Object).isRequired,
  getSingleNewOtherFees: PropTypes.instanceOf(Function).isRequired,
  getCedulaCalculationList: PropTypes.instanceOf(Function).isRequired,
  updating: PropTypes.bool.isRequired,
  ordinanceRevisionId: PropTypes.number.isRequired,
  cedulaCalculationList: PropTypes.instanceOf(Object).isRequired,
};

const mapStateToProps = ({ api }) => ({
  updating: api.loading.indexOf(c.UPDATE_CEDULA_FEES) > -1,
});

const enhance = _.flowRight([
  withForm,
  withRouter,
  connect(mapStateToProps, {
    ...actions,
  }),
]);

export default enhance(UpdateModal);
